/* ============================================================
   Service Discount form — global JS
   Self-contained: no dependency on other theme JS. Submits to the
   same Cloudflare Worker backend as the "Need Help?" widget, sent
   as multipart/form-data (not JSON) so the documentation file
   upload rides along as a real attachment.
   ============================================================ */
(function () {
  var WORKER_URL = 'https://atv-tek-contact.jj-eb7.workers.dev';
  var MAX_FILE_BYTES = 10 * 1024 * 1024;

  function init() {
    var form = document.querySelector('[data-sdf-form]');
    if (!form) return;

    var submitBtn = form.querySelector('[data-sdf-submit]');
    var statusEl = form.querySelector('[data-sdf-status]');
    var successEl = document.querySelector('[data-sdf-success]');
    var fileInput = form.querySelector('[data-sdf-file]');

    function setStatus(message, isError) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      statusEl.hidden = !message;
      statusEl.classList.toggle('sdf__status--error', !!isError);
    }

    function resetButton() {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Submit';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setStatus('');

      if (fileInput && fileInput.files[0] && fileInput.files[0].size > MAX_FILE_BYTES) {
        setStatus('That file is too large — please upload something under 10MB.', true);
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';

      fetch(WORKER_URL, {
        method: 'POST',
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (response.ok && data.ok) {
              form.hidden = true;
              if (successEl) successEl.hidden = false;
            } else {
              resetButton();
              setStatus(data.error || 'Something went wrong. Please try again, or email us at info@atv-tek.com.', true);
            }
          });
        })
        .catch(function () {
          resetButton();
          setStatus('Something went wrong. Please try again, or email us at info@atv-tek.com.', true);
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
